module.exports = __webpack_public_path__ + "img/professor_female.f2699731.png";